/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description React Hook useCodeHierarchy
 */
import { useQuery, UseQueryResult } from '@tanstack/react-query';

import QUERY_KEYS from 'app-constants/queryKeys';
import api from 'client/index';

/**
 * use code hierarchy hook
 * @returns {UseQueryResult} useCodeHierarchy
 */
const useCodeHierarchy = ({ codeId }: { codeId: string }): UseQueryResult<CodeExplorer.ICodeHierarchy> => {
	return useQuery({
		queryKey: [QUERY_KEYS.codeHierarchy, codeId],
		queryFn: async () => {
			const { data } = await api.CodeExplorerApi.codeHierarchy({ codeId });
			return data;
		},
	});
};

export default useCodeHierarchy;
